<script setup>
import 'vue3-carousel/dist/carousel.css'

import { useBreakpoints } from '@vueuse/core'
import {ref} from 'vue'
import { Carousel, Navigation, Slide } from 'vue3-carousel'

import { useHelpers } from '@/useHelpers'

import IconNavigation from './icons/IconNavigation.vue'

const { getI18nCarouselOptions } = useHelpers()

const currentSlide = ref(0)

const breakpoints = useBreakpoints({ tablet: 768 })
const isMobile = breakpoints.smaller('tablet')

const handleSlideChange = (slide) => currentSlide.value === slide
</script>

<template>
  <div class="pricing-page__forbes-dna">
    <div class="pricing-page__section-header">
      <h3>Forbes DNA</h3>
      <p class="basic-16">
        {{ $t('Forbes DNA Text') }}
      </p>
    </div>
    <div :class="[isMobile ? 'forbes-dna-card--mobile' : 'forbes-dna-card']">
      <Carousel
        :autoplay="10000"
        :transition="600"
        :items-to-show="1.1"
        snap-align="start"
        wrapAround
        pauseAutoplayOnHover
        v-model="currentSlide"
        :i18n="getI18nCarouselOptions()"
      >
        <template #addons>
          <Navigation>
            <template #next>
              <IconNavigation inverted-color />
            </template>
            <template #prev>
              <IconNavigation inverted-color mirrored />
            </template>
          </Navigation>
        </template>
        <template #slides>
          <Slide
              v-for="(slide, key) in Object.values($tm('dna'))"
              :key="`slide-${key}`"
              class="forbes-dna-card__image-wrapper"
          >
            <img
              style="background-color: gray"
              class="forbes-dna-card__image"
              :src="$rt(slide.image)"
              :alt="$rt(slide.name)"
            />
            <div class="forbes-dna-card__content">
              <p class="body-text">
                {{ $rt(slide.text) }}
              </p>
              <div>
                <h4>{{ $rt(slide.name) }}</h4>
                <p class="basic-16">{{ $rt(slide.position) }}</p>
              </div>
            </div>
          </Slide>
        </template>
      </Carousel>
    </div>
    <div class="forbes-dna-card__pagination">
      <button
        v-for="slide in Object.values($tm('dna')).length"
        :key="slide"
        class="forbes-dna-card__pagination-dot"
        :class="{
          'forbes-dna-card__pagination-dot--active': slide - 1 === currentSlide
        }"
        @click="handleSlideChange(slide - 1)"
      />
    </div>
  </div>
</template>
